import { ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import { MouseEvent, useContext } from 'react';
import { DarkMode, LightMode, SettingsBrightness } from '@mui/icons-material';
import styled from 'styled-components';
import { ColorModeContext } from '../../../../providers/MainProviders';
import MenuHeading from '../../../Typography/MenuHeading/MenuHeading';

const ThemeSwitchContainer = styled.div`
  flex-direction: column;
  align-items: flex-start;
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};
  padding-bottom: ${(props) => props.theme.spacing(2)};
`;

const ThemeSwitch = () => {
  const theme = useTheme();
  const { mode, toggleColorMode } = useContext(ColorModeContext);

  return (
    <>
      <MenuHeading text="Theme" />
      <ThemeSwitchContainer>
        <ToggleButtonGroup
          color="primary"
          size="small"
          value={mode}
          exclusive
          fullWidth
          onChange={(event: MouseEvent<HTMLElement>, newValue: string) => {
            toggleColorMode(newValue ?? 'light');
          }}
          sx={{
            '& .Mui-selected.MuiToggleButtonGroup-grouped': {
              border: `1px solid ${theme.palette.primary.main}`,
            },
          }}
        >
          <ToggleButton value="light">
            <LightMode />
          </ToggleButton>
          <ToggleButton value="system">
            <SettingsBrightness />
          </ToggleButton>
          <ToggleButton value="dark">
            <DarkMode />
          </ToggleButton>
        </ToggleButtonGroup>
      </ThemeSwitchContainer>
    </>
  );
};

export default ThemeSwitch;
